import React, {useEffect} from 'react';
import {Link} from "react-router-dom";

function Aszf() {
    document.title = "Általános szerződési feltételek"

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return <div className={"content aszf"}>
        <h1>Általános szerződési feltételek</h1>
        <h2>HSG-FÉMIPARI KFT.</h2>
        <p>Hatályos: 2025. november 5-től</p>
        <h3>1. Szolgáltató adatai</h3>
        <ul>
            <li>Cégnév: HSG-Fémipari Kft.</li>
            <li>Székhely: 4400 Nyíregyháza, Eperjes utca 12. 8. emelet 25.</li>
            <li>Cégjegyzékszám: 15 09 087918</li>
            <li>Adószám: 28833978-2-15</li>
            <li>Telefon: +36 30 480 9842</li>
            <li>E-mail: info@tetoesterkomosas.hu</li>
            <li>Weboldal: www.tetoesterkomosas.hu</li>
            <li>Képviselő: a társaság ügyvezetője</li>
        </ul>
        <p>Jelen Általános Szerződési Feltételek (továbbiakban: ÁSZF) a HSG-Fémipari Kft. által nyújtott szolgáltatások igénybevételének feltételeit szabályozzák. Az ÁSZF hatálya kiterjed a Szolgáltató és megrendelői (továbbiakban: Ügyfél) között létrejövő valamennyi szerződésre.</p>
        <h3>2. A szolgáltatás tárgya</h3>
        <p>A HSG-Fémipari Kft. tető-, térkő-, napelem- és sírkőfelületek professzionális tisztításával, mohátlanításával, valamint az ezekhez kapcsolódó karbantartási és impregnálási munkálatokkal foglalkozik.</p>
        <p>Szolgáltatásainkat lakossági és vállalati ügyfelek számára egyaránt biztosítjuk, Szabolcs-Szatmár-Bereg vármegye, Borsod-Abaúj-Zemplén vármegye, valamint Hajdú-Bihar vármegye teljes területén, külön megállapodás alapján.</p>
        <h3>3. Mengrendelés és szerződéskötés módja</h3>
        <p>A szolgáltatás megrendelése történhet a www.tetoesterkomosas.hu weboldalon elérhető ajánlatkérő űrlapon keresztül, illetve telefonon vagy e-mailben.</p>
        <p>Szükség esetén írásos árajánlatot biztosítunk, amely tartalmazza a munka pontos leírását, a díjazást és a teljesítés várható idejét.</p>
        <br/>
        <p>A munka elvégzésének ideje a tisztítani kívánt felület nagyságától és a körülményektől függően kerül meghatározásra. A megrendelés elfogadása a Szolgáltató írásos vagy szóbeli visszaigazolásával történik, ezzel a felek között szerződés jön létre.</p>
        <h3>4. Díjazás és fizetési feltételek</h3>
        <p>A szolgáltatás díja egyedi árajánlat alapján kerül meghatározásra, az árak <b>ÁFA-val növelt bruttó összegek</b>.</p>
        <p>Lakossági ügyfelek esetén a fizetés <b>készpénzben</b>, a munka elvégzésekor történik.</p>
        <p>Céges ügyfelek számára <b>átutalásos fizetésre</b> is van lehetőség, a számla kiállításától számított 8 napos fizetési határidővel.</p>
        <p>Előleg fizetése nem szükséges.</p>
        <p>Késedelmes fizetés esetén a Szolgáltató a mindenkori jegybanki alapkamat kétszeresének megfelelő késedelmi kamatot számíthat fel.</p>
        <h3>5. Teljesítés és felelősség</h3>
        <p>A munkavégzés során a Szolgáltató minden esetben törekszik a legmagasabb szakmai színvonal biztosítására.</p>
        <p>A Szolgáltató kizárólag a saját tevékenysége során keletkezett, bizonyítható károkért felelős, legfeljebb a szolgáltatás díjának mértékéig.</p>
        <p>A Szolgáltató nem vállal felelősséget:</p>
        <ul>
            <li>a felületek korábbi állaghibáiból, szerkezeti hibáiból eredő károkért,</li>
            <li>a nem megfelelően rögzített, meglazult tetőcserepek, elemek elmozdulásáért,</li>
            <li>illetve a külső időjárási körülmények (pl. szél, eső, fagy) által okozott késedelmekért vagy károkért.</li>
        </ul>
        <h3>6. Lemondás és elállás</h3>
        <p>Az Ügyfél a munkavégzés megkezdése előtt legkésőbb <b>24 órával</b> díjmentesen lemondhatja a szolgáltatást.</p>
        <p>A munkakezdés napján történő lemondás esetén a Szolgáltató jogosult a teljes megrendelt díj 30%-ának megfelelő költségtérítésre.</p>
        <p>A Szolgáltató jogosult a munkavégzést elhalasztani vagy lemondani, ha az időjárás, a helyszíni körülmények vagy a felület állapota nem teszi lehetővé a biztonságos munkavégzést.</p>
        <h3>7. Szavatosság és garancia</h3>
        <p>A Szolgáltató a munkavégzés minőségére <b>14 napos garanciát</b> vállal, amennyiben az Ügyfél a hibát haladéktalanul jelzi.</p>
        <p>A garancia nem terjed ki a természetes visszaszennyeződésre, valamint az időjárási hatások következtében bekövetkező változásokra.</p>
        <h3>8. Panaszkezelés</h3>
        <p>Az Ügyfél panaszát írásban a <b>info@tetoesterkomosas.hu</b> e-mail-címen, vagy postai úton a Szolgáltató székhelyére küldheti.</p>
        <p>A panaszokra a Szolgáltató 30 napon belül érdemi választ ad.</p>
        <p>Jogvita esetén az Ügyfél a Szolgáltató székhelye szerinti <b>Szabolcs-Szatmár-Bereg Vármegyei Békéltető Testülethez</b> fordulhat.</p>
        <h3>9. Adatkezelés</h3>
        <p>A személyes adatok kezelése a hatályos jogszabályok és a Szolgáltató <Link to={"/tajekoztato/adatkezelesi"}>Adatkezelési Tájékoztatójának</Link> megfelelően történik, amely elérhető a weboldalon: www.tetoesterkomosas.hu/adatkezeles.</p>
        <h3>10. Záró rendelkezések</h3>
        <p>A Szolgáltató jogosult az ÁSZF egyoldalú módosítására, amelyről a weboldalon tájékoztatást nyújt.</p>
        <p>Az ÁSZF-ben nem szabályozott kérdésekben a <b>Polgári Törvénykönyv</b> (2013. évi V. törvény) rendelkezései az irányadóak.</p>
        <p>A Felek jogvitáikat elsődlegesen békés úton rendezik, ennek sikertelensége esetén a <b>Nyíregyházi Járásbíróság</b> kizárólagos illetékességét kötik ki.</p>
        <br/>
        <br/>
        <p>Hatályba lépés dátuma: 2025. november 5.</p>
        <p>© 2025 HSG-Fémipari Kft. – Minden jog fenntartva.</p>
    </div>
}

export default Aszf;